// utils/hashKey.js
export const getShortKey = (url) => {
    try {
        const segments = url.split('/');

        let fileName = segments[segments.length - 1].split('?');

        return 'img_' + fileName; // img_Spaces_content_5yrs_copy.jpg
    } catch {
        return 'img_' + Math.random().toString(36).substring(2);
    }
};